

$(window).scroll(function(){
  var sticky = $('.section-header'),
      scroll = $(window).scrollTop();

  if (scroll >= 30) sticky.addClass('shopify-section-header-sticky');
  else sticky.removeClass('shopify-section-header-sticky');
});


document.addEventListener('DOMContentLoaded', function() {
  const qtyInput = document.querySelector('input[name="quantity"]');
  if (qtyInput && qtyInput.value === "1") qtyInput.value = 3;

  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function() {
      const qty = form.querySelector('input[name="quantity"]').value;
      form.querySelectorAll('input[name="quantity"]').forEach(i => i.value = qty);
    });
  });
});






// const myTimeout = setTimeout(myGreeting, 1000);

// function myGreeting() {
//     var button = document.querySelectorAll(".rapi-bundles__bar");
//     console.log(button);
//     $(button).click(function(){
//         console.log('click');
//     });
// }




function headerColor(){
    if($('.page-banner').hasClass('white')){
        $('header.header').removeClass('home-header');
    }else{
        
    }
}
headerColor();
$(window).on('load',function(){
    headerColor();
});


  



// $(document).ready(function(){
// setTimeout(function() {
//   $('.product-related-slider').slick({
//         infinite: true,
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         // arrows: true,
//         prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>',
//         nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>'
       
//         });
// }, 3000);
// });


     if( $('.best-seller-slider').length )  {

        new Splide( '.best-seller-slider', {
            type: "loop",
            perPage: 4,
            arrows: true,
            pagination: false,
            focus:false,
            gap: "10px",
            autoplay: true,
            //autoWidth: true,
            breakpoints: {
                800: {
                    perPage: 2,
                },
                500: {
                    perPage: 1,
                },
            }
        }).mount();

    }

 if( $('.ticker-slider-js').length )  {

    new Splide( '.ticker-slider-js', {
        type: "loop",
        perPage: 4,
        arrows: false,
        pagination: false,
        focus:false,
        gap: "30px",
        autoWidth: true,
        breakpoints: {
            701: {
                //gap: "60px",
            },
        }
    }).mount(window.splide.Extensions);

}

if( $('.client-review').length )  {
    var main = new Splide( '.review-caption-slider', {
         type   : 'loop',
        type       : 'fade',
        pagination : false,
        arrows     : false,
    } );

    var thumbnails = new Splide( '.review-image-slider', {
         type   : 'loop',
        perPage: 3,
        perMove: 1,
        rewind          : false,
        isNavigation    : true,
        gap             : 10,
        pagination      : false,
        dragMinThreshold: {
            mouse: 4,
            touch: 10,
        },
        breakpoints : {
            1100: {
                perPage: 2,
            },
            800: {
                perPage: 1,
                arrows : false,
                pagination  : true,
            },
        },
    } );

    main.sync( thumbnails );
    main.mount();
    thumbnails.mount();
}

// $('.accordion .toggle').click(function(e) {
//   	e.preventDefault();
  
//     let $this = $(this);
  
//     if ($this.next().hasClass('show')) {
//         $this.next().removeClass('show');
//         $this.next().slideUp(350);
//     } else {
//         $this.parent().parent().find('li .inner').removeClass('show');
//         $this.parent().parent().find('li .inner').slideUp(350);
//         $this.next().toggleClass('show');
//         $this.next().slideToggle(350);
//     }
// });



$('.accordion .toggle').click(function(e) {
    e.preventDefault();

    let $this = $(this);
    let $li = $this.closest('li');

    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show').slideUp(350);
        $li.removeClass('show'); // remove class from li
    } else {
        // Close all
        $this.parent().parent().find('li .inner').removeClass('show').slideUp(350);
        $this.parent().parent().find('li').removeClass('show');

        // Open current
        $this.next().addClass('show').slideDown(350);
        $li.addClass('show'); // add class to li
    }
});

// Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});


if( $('.insynergy-text-slider-js').length )  {

    new Splide( '.insynergy-text-slider-js', {
        type: "loop",
        perPage: 4,
        arrows: false,
        pagination: false,
        focus:false,
        gap: "53px",
        autoWidth: true,
        autoScroll: {
            speed: 1,
            pauseOnHover: false,
            pauseOnFocus: false,
        },
        breakpoints: {
            701: {
                //gap: "60px",
            },
        }
    }).mount(window.splide.Extensions);

}


if( $('.gallery-slider').length )  {

    // new Splide( '.gallery-js', {
    //     type: "loop",
    //     perPage: 3,
    //     padding: '15rem',
    //     arrows: false,
    //     pagination: false,
    //     focus:false,
    //     gap: "18px",
    //     autoplay: true,
    //     autoScroll: {
    //         speed: 1,
    //         pauseOnHover: false,
    //         pauseOnFocus: false,
    //     },
    //     //autoWidth: true,
    //     breakpoints: {
    //         800: {
    //             perPage: 2,
    //         },
    //         600: {
    //             perPage: 1,
    //             padding: '4rem',
    //         },
    //     }
    // }).mount(window.splide.Extensions);

    new Splide( '.gallery-js', {
        type: "loop",
        perPage: 4,
        arrows: false,
        pagination: false,
        focus:false,
        gap: "18px",
        autoWidth: true,
        autoScroll: {
            speed: -1,
            pauseOnHover: false,
            pauseOnFocus: false,
        },
        breakpoints: {
             800: {
                perPage: 2,
            },
            600: {
                perPage: 1,
                padding: '4rem',
            },
        }
    }).mount(window.splide.Extensions);
}




if( $('.powerful-ingredients-wrap').length ) {
    var main  = new Splide( '.powerful-ingredients-wrap .ingredient_image_slide', {
        type   : 'loop',
        // padding: '5rem',
        focus    : 'center',
        autoWidth: true,
        gap: "20vw",
        //fixedHeight: 355,
        drag: false,
        arrows: true,
        pagination: false,
        breakpoints: {
            600: {
                arrows: false,
                pagination: true,
                drag: true,
            }
        }
    });

    var ingredient_text  = new Splide( '.powerful-ingredients-wrap .ingredient_text_slide', {
        type   : 'loop',
        // padding: '5rem',
        focus    : 'center',
        autoWidth: false,
        gap: "0",
        arrows: false,
        drag: false,
        pagination: false
    });

    main.sync( ingredient_text );
    main.mount();
    ingredient_text.mount();
}


